/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {StoreService} from 'compob2b-libs';
import {translations} from '../../../../environments/translations.ru';
import {BreadcrumbService} from '../../breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'app-cart',
    providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
    templateUrl: './cart.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CartComponent implements OnInit {

  constructor(private readonly storeService: StoreService, private readonly breadcrumbService: BreadcrumbService) {

      this.storeService.setTitle(translations.cart);

  }

  ngOnInit() {
    this.storeService.setTitle(translations.titles.cart);
    this.breadcrumbService.viewBreadcrumbs(false);
  }
}
